var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFasciaFootpatrol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-FP-logo-16px"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FP-logo-16px",
    clipPath: "url(#clip-FP-logo-16px)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69",
    transform: "translate(0 7.253)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M1.3,1.038H.943V.884H.514v.5H.859v.244H.514v.536h.12v.222H0V2.164H.094V.884H0V.6H1.3Z",
    transform: "translate(0 -0.597)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M969.005,1.048h-.273V.784h-.316V2.065h.088v.222h-.6V2.065h.088V.784h-.315v.263H967.4V.5H969v.548Z",
    transform: "translate(-962.844 -0.498)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M1365.652,1.329a.3.3,0,0,1-.312.334h-.52v.5h.1v.222h-.622V2.164h.094V.884h-.094V.6h1.04c.2,0,.312.124.312.349Zm-.832-.445v.562h.417V.884Z",
    transform: "translate(-1357.876 -0.597)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M1658.812,2.065v.222h-.48l-.062-.417h-.442s-.047.333-.06.417h-.469V2.065h.074l.3-1.565h.784l.294,1.565Zm-.822-1.24-.113.747h.349l-.11-.747Z",
    transform: "translate(-1649.495 -0.498)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M2399.558,2.386h-.4c0-.063,0-.746,0-.746h-.445v.746h-.52V2.164h.094V.884h-.094V.6h1.045a.3.3,0,0,1,.315.335v.306c0,.162-.23.209-.23.209l-.005.031s.236,0,.235.322C2399.56,1.8,2399.558,2.285,2399.558,2.386Zm-.839-1.5V1.4h.423V.884Z",
    transform: "translate(-2386.907 -0.597)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M326.745.7h-.63a.3.3,0,0,0-.315.336V2.151a.3.3,0,0,0,.315.336h.631a.3.3,0,0,0,.315-.336V1.036A.3.3,0,0,0,326.745.7Zm-.1,1.512h-.4V.971h.4Z",
    transform: "translate(-324.286 -0.697)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M2000,1.147h-.273V.884h-.316v1.28h.088v.222h-.6V2.164h.088V.884h-.316v.263h-.273V.6h1.6v.547Z",
    transform: "translate(-1988.987 -0.597)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M649.845.7h-.631a.3.3,0,0,0-.315.336V2.151a.3.3,0,0,0,.315.336h.631a.3.3,0,0,0,.314-.336V1.036A.3.3,0,0,0,649.845.7Zm-.506,1.512V.971h.4V2.212Z",
    transform: "translate(-645.845 -0.697)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M2752.96.336a.3.3,0,0,0-.315-.336h-.63a.3.3,0,0,0-.315.336V1.45a.3.3,0,0,0,.315.336h.63a.3.3,0,0,0,.314-.336Zm-.418,1.176h-.4V.271h.4Z",
    transform: "translate(-2738.72 0)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M3094.387,2.186H3093.1V1.932h.095V.684h-.095V.4h.611V.684h-.1V1.932h.424V1.673h.348Z",
    transform: "translate(-3078.535 -0.398)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M3273.483,97.667l-.184-.136-.185.135.072-.217-.186-.134.229,0,.071-.218.069.218h.229l-.186.133Z",
    transform: "translate(-3257.598 -96.641)",
    fill: "#111"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFasciaFootpatrol);
export default __webpack_public_path__ + "static/media/logo-fascia-footpatrol.2fb5157a.svg";
export { ForwardRef as ReactComponent };